import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../state/AuthContext";

// Authentication guard only. Onboarding gating lives in a single place —
// the render-time <OnboardingGate> in App.tsx — so this component no longer
// duplicates that logic.
export default function ProtectedRoute({ children }) {
  const { isAuthenticated, isAuthReady } = useAuth();
  const location = useLocation();

  if (!isAuthReady) {
    return null;
  }

  if (!isAuthenticated) {
    const redirectTarget = `${location.pathname}${location.search}`;
    return (
      <Navigate
        to={`/connexion?redirect=${encodeURIComponent(redirectTarget)}`}
        replace
      />
    );
  }

  return children;
}
